import TextField from '@mui/material/TextField';
import { useState, FC } from 'react';
import { InputAdornment, TextFieldProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CopyToClipboardButton from '../CopyToClipboardButton/CopyToClipboardButton';

type PasswordTextFieldProps = TextFieldProps & {
    showCopyButton?: boolean;
};

const PasswordTextField: FC<PasswordTextFieldProps> = ({ showCopyButton, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    return (
        <TextField
            slotProps={{
                input: {
                    sx: {
                        pr: 1,
                    },
                    type: showPassword ? 'text' : 'password',
                    endAdornment: (
                        <InputAdornment sx={{ display: 'flex', gap: 0.25 }} position="end">
                            {showCopyButton && (
                                <CopyToClipboardButton
                                    textToCopy={String(props.value) || String(props.defaultValue) || ''}
                                />
                            )}
                            <IconButton
                                size="small"
                                aria-label={showPassword ? 'hide the password' : 'display the password'}
                                onClick={handleClickShowPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
            {...props}
        />
    );
};

export default PasswordTextField;
